const NAME = "ACTION_TYPES";

export default NAME;
